<!-- Ссылки на настройки документов компании. -->
<template>
  <SettingSection
    title="Документы"
    icon-variant="documents"
    :icon="icon"
    :links="links"
  />
</template>

<script>
import SettingSection from "@/components/Settings/SettingSection.vue";

export default {
  name: "DocumentsSettingsSection",

  components: {
    SettingSection,
  },

  data() {
    return {
      icon: `
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
        <line x1="16" y1="13" x2="8" y2="13"></line>
        <line x1="16" y1="17" x2="8" y2="17"></line>
        <polyline points="10 9 9 9 8 9"></polyline>
      `,
      links: [
        {
          label: "Пользовательские поля",
          route: { name: "RequisiteTypes" },
        },
        {
          label: "Шаблоны документов",
          route: { name: "Templates" },
        },
        {
          label: "Файлы компании",
          route: { name: "CompanyAttachments" },
        },
      ],
    };
  },
};
</script>
